import { QueryClient } from '@tanstack/react-query';

/** TanStack owns only reads explicitly migrated from the Zustand remote store. */
export const serverQueryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: false, gcTime: 5 * 60_000 },
  },
});

export const commandCenterSummaryKey = ['dashboard', 'command-center-summary'] as const;
